import { render } from "./packageFee.vue?vue&type=template&id=a02cfddc&scoped=true"
import script from "./packageFee.vue?vue&type=script&lang=js"
export * from "./packageFee.vue?vue&type=script&lang=js"

import "./packageFee.vue?vue&type=style&index=0&id=a02cfddc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a02cfddc"

export default script